import axios from 'axios';
import role from './role';
import permission from './permission';
import assignment from './assignment';
import mappingMID from './mappingMID';
import mappingWilayah from './mappingWilayah';
import mappingCabang from './mappingCabang';

const rbac = {
  namespaced: true,

  state() {
    return {
      isLoading: false,
    };
  },

  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading;
    },
  },

  actions: {
    async fetchUserMenu(ctx) {
      ctx.commit('setLoading', true);
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/menu/access-menu`,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'X-Origin-Path': window.location.pathname
        },
      };
      return axios(config)
        .then((response) => {
          if (response.data.code == '200') {
            return response.data.data;
          }
          if (response.data.code == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return false;
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return false;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
  },

  modules: {
    role,
    permission,
    assignment,
    mappingMID,
    mappingWilayah,
    mappingCabang,
  },
};
export default rbac;
